import React, {useCallback, useEffect} from 'react';
import {useLocation, useNavigate} from 'react-router';
import {useTranslation} from 'react-i18next';
import {Location} from 'history';
import {callNativeWeb, footerShowEventWeb} from 'common/appInterface';

const CardAutoDebitPage: React.FC = () => {
  /** Location State */
  const location = useLocation() as Location<LocationState>;
  /** Navigate */
  const navigate = useNavigate();
  /** 다국어처리 */
  const { t, i18n } = useTranslation();

  const screenId = 'SERV15';
  const screenName = t('SERV15.title');

  /** 뒤로가기 처리 (backKeyEvent_App (APP > WEB)) */
  const callbackBackkeyEvent = useCallback(() => {
    if (location.state.linkOpenMenu === 'main') {
      navigate("/main", {
        state: {
          query: location.state.query
          ,swiperIndex: location.state.swiperIndex
          ,tabIndex: location.state.tabIndex
          ,from: location.pathname
        }
      });
    } else {
      navigate(-1);
    }
  }, [navigate, location.state.linkOpenMenu, location.state.query, location.state.swiperIndex, location.state.tabIndex, location.pathname]);

  // 최초실행
  useEffect(() => {
    // 언어설정
    i18n.changeLanguage(location.state.query.languageCode);
    // callNative_Web 처리 (WEB > APP)
    callNativeWeb(screenId, screenName, location.state.from === '/intro' ? 'Y' : 'N');
    // 하단바 숨기기
    footerShowEventWeb('N');

    console.log('QUERY STATE');
    console.log(location.state);

    // 최초한번실행 useEffect() Warning 제거
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 뒤로가기 이벤트 리스너 (backKeyEvent_App (APP > WEB))
  useEffect(() => {
    document.addEventListener('backpress', callbackBackkeyEvent);
    return () => document.removeEventListener('backpress', callbackBackkeyEvent);
  }, [callbackBackkeyEvent]);

  return (
    <div id='wrap'>
      <div id='container' className='pcHidden'>
        <section className='contents listtyp01'>
          <div className='inner mgt30'>
            <section className='manage'>
              <p className='tit mgt15'>
                {t('SERV15.explan01')}
              </p>
            </section>
          </div>
        </section>
      </div>
    </div>
  );
};

export default CardAutoDebitPage;